export default "__VITE_ASSET__c21cbb5e__"